{
    angular.module('interfaceModule')
        .controller('UseProcessController',UseProcessController);
    UseProcessController.$inject = ['$scope',"utils.currentUser",'utils.constant','$state'];
    function UseProcessController($scope,currentUser,constant,$state) {
        let vm=this;
        let collect={
            'activate':activate,

        };
        vm.collect=collect;
        activate();

        function activate(){

        }
    }

}